module.exports = __webpack_public_path__ + "static/img/pies.d01bb804.webp";